import { useMemo } from 'react'
import { dayjs, duration } from '@/shared/lib/dayjs'
import { useTick } from '@/shared/lib/use-tick'

dayjs.extend(duration)

export interface CountdownProps {
  time?: string
  totalHour?: number
  title?: string
  height?: string
  fontSize?: string
  width?: string
  hideSeconds?: boolean
  colorMode?: boolean
}

export function Countdown({
  time = '04:00:00',
  title,
  height,
  fontSize = '16px',
  width = '350px',
  hideSeconds = false,
  colorMode = false,
}: CountdownProps) {
  const now = useTick()

  // deadline faqat time o'zgarganda qayta hisoblanadi — drift yo'q
  const deadline = useMemo(() => {
    const parts = time.split(':').map(Number)
    const ms = dayjs
      .duration({ hours: parts[0], minutes: parts[1], seconds: parts[2] })
      .asMilliseconds()
    return Date.now() + ms
  }, [time])

  const remainingMs = Math.max(0, deadline - now)
  const d = dayjs.duration(remainingMs)

  const hh = String(Math.floor(d.asHours())).padStart(2, '0')
  const mm = String(d.minutes()).padStart(2, '0')
  const ss = String(d.seconds()).padStart(2, '0')

  const formatted =
    remainingMs <= 0
      ? hideSeconds ? '00:00' : '00:00:00'
      : hideSeconds ? `${hh}:${mm}` : `${hh}:${mm}:${ss}`

  const isExpired = remainingMs <= 0

  const totalMinutes = remainingMs / 60000
  const timeColor = colorMode
    ? isExpired || totalMinutes < 10
      ? 'var(--danger-font-color)'
      : totalMinutes < 20
        ? 'var(--warning-font-color)'
        : 'var(--primary-font-color)'
    : undefined

  return (
    <div
      className="flex items-center justify-between glasspro-countdown"
      style={{ width, height }}
    >
      {title && <span className="text-xs text-gray-500 mr-2">{title}</span>}
      <span
        style={{ fontSize, color: timeColor }}
        className={`font-mono tabular-nums ${!colorMode && isExpired ? 'text-red-500' : ''}`}
      >
        {formatted}
      </span>
    </div>
  )
}
